import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetAddedAssignedUserLeads } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

// leads the current user is added to as advisor
export const useAddedAssignedUserLeads = () => {
    const queryKey = queryKeys.getAddedAssignedUserLeads();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAddedAssignedUserLeads,
        schema: schemaLoanRequestResolver_GetAddedAssignedUserLeads,
        searchParams: { position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
